// @flow
import LeagueWarning from './LeagueWarning'

export default LeagueWarning
